export default __webpack_public_path__ + "static/media/ciclo-de-conferencias_banner_movilsinboton.dffaf5bb.jpg";